<template>
  <div>
    <div class="title" @click="goBack">
      <van-icon name="arrow-left" />
      <h2>公司介绍</h2>
    </div>
    <div class="content">
      <div class="company-name">
        中科金联（北京）科技有限公司
      </div>
      <p class="company-desc">
        中科金联（北京）科技有限公司，是新一代智能开源情报大数据收集及应用的国家高新技术企业，荣获两大科技进步奖；取得左轮、罗盘、积木三项数据挖掘及分析专利；成立四个实战应用实验室。
      </p>
      <p class="company-desc">
        自主研发的猎寻网络足迹监测系统，基于LBS数据挖掘技术对内容、人、企业三方面进行信息分析，及时发现深层次、预警性、行动性情报信息，为用户实时推送每天网上发布的潜在热点，帮助用户生成战略研判报告。公司专注于多源数据融合技术，赋能业务工作智能化，致力于服务打击各类违法犯罪。

      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: "introduce",
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>
<style scoped>
.title {
  padding: 20px 20px 10px;
  font-size: 20px;
  font-weight: bold;
  border-bottom: 1px solid #ccc;
  display: flex;
  align-items: center;
}

.content {
  padding: 20px;
}

.company-name {
  text-align: center;
  font-size: 18px;
  line-height: 48px;
}

.company-desc {
  text-align: center;
  line-height: 30px;
  font-style: italic;
  text-indent: 2em;
  letter-spacing: 2px;
}
</style>
